<template>
  <div id="app" class="d-flex flex-column min-vh-100">
    <Navbar />
    <main class="flex-grow-1">
      <router-view/>
    </main>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Navbar,
    Footer
  }
}
</script>

<style>
/* Global styles */

/* Define custom color properties */
:root {
  --eb-primary: #02eebe;
  --eb-dark: #333333;
  --bs-primary: var(--eb-primary); /* Override Bootstrap primary color */
  --bs-primary-rgb: 2, 238, 190; /* RGB version of #02eebe */
  --bs-link-color: var(--eb-primary);
  --bs-link-hover-color: color-mix(in srgb, var(--eb-primary) 80%, black);
  --bs-body-color: var(--eb-dark); /* Default text color */
}

/* Ensure content doesn't hide behind the fixed navbar */
body {
  color: var(--bs-body-color);
}

html {
   scroll-padding-top: 70px; /* Match body padding-top */
   scroll-behavior: smooth;
}

/* Ensure the app container takes full height */
/* d-flex flex-column min-vh-100 are applied via classes */
#app {
}

main {
  /* flex-grow-1 is applied via class */
}

/* Force all buttons to be bold */
.btn {
    font-weight: bold !important;
}

/* --- Force Button Styles --- */

/* .btn-primary */
.btn-primary,
.btn-primary:focus,
.btn-primary:active:focus {
    background-color: var(--eb-primary) !important;
    border-color: var(--eb-primary) !important;
    color: var(--eb-dark) !important; /* Ensure contrast */
    box-shadow: none !important; /* Optional: remove default focus shadow if needed */
}

.btn-primary:hover {
    background-color: color-mix(in srgb, var(--eb-primary) 90%, white) !important;
    border-color: color-mix(in srgb, var(--eb-primary) 90%, white) !important;
    color: var(--eb-dark) !important;
}

.btn-primary:active {
    background-color: color-mix(in srgb, var(--eb-primary) 85%, black) !important;
    border-color: color-mix(in srgb, var(--eb-primary) 85%, black) !important;
    color: var(--eb-dark) !important;
}

.btn-primary:disabled,
.btn-primary.disabled {
    background-color: color-mix(in srgb, var(--eb-primary) 50%, white) !important;
    border-color: color-mix(in srgb, var(--eb-primary) 50%, white) !important;
    color: var(--eb-dark) !important;
}

/* .btn-outline-primary */
.btn-outline-primary,
.btn-outline-primary:focus,
.btn-outline-primary:active:focus {
    color: var(--eb-primary) !important;
    border-color: var(--eb-primary) !important;
    background-color: transparent !important; /* Ensure no background */
    box-shadow: none !important; /* Optional: remove default focus shadow if needed */
}

.btn-outline-primary:hover {
    color: var(--eb-dark) !important;
    background-color: var(--eb-primary) !important;
    border-color: var(--eb-primary) !important;
}

.btn-outline-primary:active {
    color: var(--eb-dark) !important;
    background-color: color-mix(in srgb, var(--eb-primary) 95%, black) !important; /* Slightly darker active state */
    border-color: color-mix(in srgb, var(--eb-primary) 95%, black) !important;
}

.btn-outline-primary:disabled,
.btn-outline-primary.disabled {
    color: color-mix(in srgb, var(--eb-primary) 50%, white) !important;
    border-color: color-mix(in srgb, var(--eb-primary) 50%, white) !important;
    background-color: transparent !important;
}

/* --- End Force Button Styles --- */

/* Force background color for bg-primary */
.bg-primary {
  background-color: var(--eb-primary) !important;
}

/* Adjust text colors if needed */
.text-primary {
    color: var(--eb-primary) !important;
}

.text-dark {
  color: var(--eb-dark) !important;
}

/* Navbar active link */
.navbar .nav-link.active {
  color: var(--eb-primary) !important;
  font-weight: bold;
}

/* Footer link colors */
footer.bg-dark a.text-light {
    color: rgba(255, 255, 255, 0.75) !important;
}
footer.bg-dark a.text-light:hover {
    color: var(--eb-primary) !important;
    text-decoration: underline;
}

</style>
